// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1GnvT","content":"GlobalSearch_content__fiQmN"};